(function () {
  var tooltipSelector = '.jc-price-tooltip';
  var bubbleSelector = '.jc-price-tooltip__bubble';
  var viewportGap = 12;

  function positionTooltip(tooltip) {
    var bubble = tooltip && tooltip.querySelector(bubbleSelector);

    if (!bubble) {
      return;
    }

    bubble.style.setProperty('--jc-price-tooltip-shift', '0px');

    window.requestAnimationFrame(function () {
      var rect = bubble.getBoundingClientRect();
      var rightLimit = window.innerWidth - viewportGap;
      var shift = 0;

      if (rect.left < viewportGap) {
        shift = viewportGap - rect.left;
      } else if (rect.right > rightLimit) {
        shift = rightLimit - rect.right;
      }

      bubble.style.setProperty('--jc-price-tooltip-shift', Math.round(shift) + 'px');
    });
  }

  function findTooltip(target) {
    if (!target || !target.closest) {
      return null;
    }

    return target.closest(tooltipSelector);
  }

  document.addEventListener('pointerover', function (event) {
    positionTooltip(findTooltip(event.target));
  });

  document.addEventListener('focusin', function (event) {
    positionTooltip(findTooltip(event.target));
  });

  document.addEventListener('click', function (event) {
    positionTooltip(findTooltip(event.target));
  });

  window.addEventListener('resize', function () {
    document
      .querySelectorAll(tooltipSelector + ':hover, ' + tooltipSelector + ':focus-within')
      .forEach(positionTooltip);
  });
})();
